import React from 'react';
import IconAmenityShuttle from '@spothero/icons/amenity-shuttle';
import IconTrainFilled from '@spothero/icons/train-filled';
import { Flex, Icon, Box } from '@spothero/ui';
export const getTransportationDetails = type => {
    switch (type) {
        case 'scheduled':
        case 'scheduled-shuttle':
            return {
                text: 'Scheduled Shuttle',
                shuttleIcon: IconAmenityShuttle,
            };
        case 'on-demand':
        case 'on-demand-shuttle':
            return {
                text: 'On Demand Shuttle',
                shuttleIcon: IconAmenityShuttle,
            };
        case 'public-transit':
            return {
                text: 'Public Transit Access',
                shuttleIcon: IconTrainFilled,
            };
        default:
            return { text: '', shuttleIcon: null };
    }
};
const AirportCardTransportation = ({ type = '' }) => {
    const { text: transportationText, shuttleIcon } = getTransportationDetails(type);
    if (!transportationText || !shuttleIcon) {
        return null;
    }
    return (<Flex alignItems="center" gap="0.5" my="1" data-testid="AirportCardTransportation">
            <Icon as={shuttleIcon}/>
            <Box data-testid="AirportCardTransportation-text" 
    // eslint-disable-next-line react/forbid-component-props
    style={{
            display: '-webkit-box',
            WebkitLineClamp: 1,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        }}>
                {transportationText}
            </Box>
        </Flex>);
};
export default AirportCardTransportation;
